<template>
    <div class="warehouse-show__wrapper">
        <div class="app__card_show warehouse-show">
            <div class="app__card-header warehouse-show__card-header">
                <div>{{ warehouse.name }}</div>
                <div>
                    <span
                        class="warehouse__icon_space_after"
                        @click="$emit('edit', warehouse)"
                        v-html="$tc('icons.edit')"
                    ></span>
                    <span class="warehouse__icon" @click="deleteWarehouse" v-html="$tc('icons.delete')"></span>
                </div>
            </div>
            <div class="app__card-body">
                <template v-if="hasServer">
                    <div class="warehouse-show__text">{{ $tc("words.server") }}</div>
                    <div class="warehouse-show__text">
                        <a class="warehouse-show__link" :href="server.url">
                            <span class="warehouse__icon_space_after" v-html="$tc('icons.server')"></span>
                            <span>{{ server.url }}</span>
                        </a>
                    </div>
                </template>
                <div v-if="hasAdministrationUI" class="warehouse-show__text">
                    <span>{{ $tc("warehouses.withAdministrationUI") }}</span>
                    <a class="warehouse-show__link" :href="administrationUI.url">
                        <span class="warehouse__icon_space_before" v-html="$tc('icons.dashboard')"></span>
                    </a>
                </div>
                <hr class="warehouse-show__separator" />
                <div class="warehouse-show__text" v-if="hasExportService">
                    <sah-button class="warehouse-show__button_space_after" @click.native="$emit('export', warehouse)">
                        <span v-html="$tc('icons.export')"></span>
                    </sah-button>
                    <span>{{ $tc("warehouses.export") }}</span>
                </div>
                <div class="warehouse-show__text">
                    <sah-button class="warehouse-show__button_space_after" @click.native="$emit('import', warehouse)">
                        <span v-html="$tc('icons.import')"></span>
                    </sah-button>
                    <span>{{ $tc("warehouses.import") }}</span>
                </div>
                <hr class="warehouse-show__separator" />
                <template v-if="hasUploadService">
                    <div class="warehouse-show__text">{{ $tc("warehouses.uploadService") }}</div>
                    <div class="warehouse-show__upload-container">
                        <div class="warehouse-show__upload-area">{{ $tc("warehouses.uploadPackage") }}</div>
                    </div>
                    <hr class="warehouse-show__separator" v-if="hasUploadService" />
                </template>
                <div v-if="hasContact" class="warehouse-show__text">
                    <span>{{ $tc("warehouses.createdBy") }} </span>
                    <a class="warehouse-show__link" :href="`mailto:${warehouse.contactEmail}`">
                        <span class="warehouse__icon_space_after" v-html="$tc('icons.email')"></span>
                        <span>{{ warehouse.contactName }}</span>
                    </a>
                </div>
                <div v-if="warehouse.creationDate" class="warehouse-show__text">
                    <span>{{ $tc("warehouses.createdOn") }} </span>
                    <span>{{ warehouse.creationDate }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {store} from "atom";
import {SahButton} from "atom";
const {createNamespacedHelpers} = store;
const {mapActions} = createNamespacedHelpers("arcman");
/**
 *
 * @vue-prop {Object} warehouse - warehouse
 */
export default {
    name: "warehouse-show",
    components: {SahButton},
    props: {
        warehouse: {type: Object, required: true},
    },
    computed: {
        server() {
            return this.warehouse.links.find(element => element.key === "serverUrl");
        },
        administrationUI() {
            return this.warehouse.links.find(element => element.key === "administrationUI");
        },
        exportService() {
            return this.warehouse.links.find(element => element.key === "exportService");
        },
        uploadService() {
            return this.warehouse.links.find(element => element.key === "uploadService");
        },
        hasContact() {
            return this.warehouse.contactEmail && this.warehouse.contactName;
        },
        hasServer() {
            return this.server.url;
        },
        hasAdministrationUI() {
            return this.administrationUI.url;
        },
        hasExportService() {
            return this.exportService.url;
        },
        hasUploadService() {
            return this.uploadService.url;
        },
    },
    methods: {
        ...mapActions({
            warehouseDestroy: "WAREHOUSE_DESTROY",
        }),
        deleteWarehouse() {
            this.$modal.dialog(this.$t("warehouses.confirmDelete", {name: this.warehouse.name})).then(confirm => {
                if (confirm) {
                    this.warehouseDestroy(this.warehouse);
                }
                this.$modal.hide();
            });
        },
    },
};
</script>

<style scoped lang="scss">
.warehouse-show__wrapper::v-deep {
    .warehouse-show {
        border-color: $border-warehouse-card-color;
    }

    .warehouse-show__card-header {
        background-color: $background-warehouse-card-header-color;
    }

    .warehouse__icon {
        @apply px-0;
    }

    .warehouse-show__text {
        @apply py-2;
    }

    .warehouse__icon_space_after {
        @apply pr-2;
    }

    .warehouse__icon_space_before {
        @apply pl-2;
    }

    .warehouse-show__separator {
        @apply -mx-5 block border-0;
        background-color: $background-warehouse-card-separator-color;
        height: $separator-height;
    }

    .warehouse-show__link {
        @apply no-underline;
        color: $text-anchor-color;
    }

    .warehouse-show__button_space_after {
        @apply mr-2;
    }

    .warehouse-show__upload-container {
        @apply w-full mb-4 rounded;
        background-color: $background-upload-area-color;
    }

    .warehouse-show__upload-area {
        @apply w-full p-4 border border-dashed text-center rounded;
        border-color: $border-upload-area-color;
    }
}
</style>
